const BRAND = "NicheHire";

export const copy = {
  brand: BRAND,
  nav: {
    links: [
      { href: "#problem", label: "Problem" },
      { href: "#vision", label: "Vision" },
      { href: "#portal", label: "Portal" },
      { href: "#product", label: "Product" },
      { href: "#use-cases", label: "Use cases" },
    ],
    cta: "Join waitlist",
  },
  hero: {
    eyebrow: "For engineering leaders",
    headlinePre: "The gap between your ",
    headlineEmphasis1: "interview",
    headlineMid: " and your ",
    headlineEmphasis2: "job description",
    headlineSuffix: " is",
    headlineUnderline: "costing you hires.",
    sub: "Fix the interview. Hire the engineers your job description actually asks for — not the ones who happen to ace algorithm puzzles.",
  },
  problem: {
    eyebrow: "What's broken",
    title: "Your interview has nothing to do with the job.",
    lede: "Most teams hiring for niche technical roles run one of three interviews. None of them tell you whether this person can do the work.",
  },
  vision: {
    eyebrow: "What if instead",
    title: "Candidates work in the interview the way they'd work on day one.",
    lede: "Same toolchain. Same shell. Same feedback loop. You stop guessing and start watching.",
  },
  portal: {
    eyebrow: "How it works",
    lede: `${BRAND} comes with ready-to-go environments for niche domains. Or compose your own — add the tools your team actually uses, arrange the layout, write the problem. Save it. Every candidate gets the exact same environment.`,
    ctaTitle: "Join the waitlist — tell us which domains you hire for.",
  },
  product: {
    eyebrow: "How it works",
    title: "Built for your stack — not a generic one.",
    lede: "Pre-built environments for the most common niche domains. Or compose your own with the exact tools your team already uses.",
    customizeTitle: "Or bring your own stack.",
    customizeBody:
      "Add the tools your team actually uses. Configure the layout. Write your own problem. Save it as a template and reuse it for every candidate. The interview looks exactly like your day-one development environment — because you built it that way.",
    cta: "Join the waitlist",
  },
  useCases: {
    eyebrow: "Use cases",
    title: "Three roles, three real environments.",
    lede: "We're starting with the domains where the gap between interview and job is widest.",
  },
  footerCta: {
    eyebrow: "Early access",
    title: "We're building this with the first teams who join.",
    lede: "Tell us what you interview for. We'll send a heads-up the week before access opens.",
    privacy: "No spam. Just early access.",
  },
  footer: {
    copyright: `© ${new Date().getFullYear()} ${BRAND}`,
    contact: "contact@nichehire.io",
  },
};
